// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__a8v8e","noContent":"styles_noContent__NfntJ"};